<div class="splash-screen">
  <div class="splash-screen__wrapper">
    <img class="splash-screen__logo" src="/assets/fusus-icons/fusus-animation.gif" alt="Loading" />
  </div>
</div>
